import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FieldAccordion from './components/FieldAccordion';
import FieldTypeSelector from './components/FieldTypeSelector';
import FieldControls from './components/FieldControls';
import FieldLabel from './components/FieldLabel';
import FieldGroupType from './components/FieldTypeSelector/fieldTypes/FieldGroupType';
import DriveNewFieldsModal from './components/DriveNewFieldsModal';

const propTypes = {
  index: PropTypes.number,
  fieldName: PropTypes.string,
  onRemove: PropTypes.func,
  fieldData: PropTypes.object,
  parentFields: PropTypes.object,
  dragHandleProps: PropTypes.object,
};

function TemplateField({
  index,
  fieldName,
  fieldData,
  parentFields,
  onRemove,
  dragHandleProps,
}) {
  const [openDrivedModal, setOpenDrivedModal] = useState(false);
  return (
    <FieldAccordion
      id={`${fieldName}-template-field-${index}`}
      fieldName={fieldName}
      fieldData={fieldData}
      onRemove={onRemove}
      index={index}
      closedByDefault
      dragHandleProps={dragHandleProps}
    >
      <FieldControls
        fieldData={fieldData}
        fieldName={fieldName}
        setOpenDrivedModal={setOpenDrivedModal}
      />
      <FieldLabel fieldData={fieldData} fieldName={fieldName} />
      {/** To avoid Dependency cycle via ../../EditFieldGroupModal,
       * we need to call FieldGroupType component
       * outside FieldTypeSelector component
       */}
      {fieldData.type === 'fieldArray' ? (
        <FieldGroupType
          fieldData={fieldData}
          fieldName={fieldName}
          parentFields={parentFields}
          parentFieldIndex={index}
        />
      ) : (
        <FieldTypeSelector fieldName={fieldName} fieldData={fieldData} />
      )}
      <DriveNewFieldsModal
        open={openDrivedModal}
        onClose={() => setOpenDrivedModal(false)}
        fieldData={fieldData}
        fieldName={fieldName}
        parentFields={parentFields}
        parentFieldIndex={index}
      />
    </FieldAccordion>
  );
}

TemplateField.propTypes = propTypes;

export default TemplateField;
